var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","flex-direction":"row-reverse","align-items":"center"},style:({ width: _vm.changeWidth }),on:{"click":_vm.switchClickEvent}},[_c('a',{staticClass:"switch",class:{ active: _vm.isOn }},[_c('span')])])}
var staticRenderFns = []

export { render, staticRenderFns }